import React, { FunctionComponent } from 'react'
import { Row } from '@paypalcorp/pp-react'

import { VideoStrip } from './VideoStrip'

interface RelatedVideosPlaylistProps {
  title: string
  videos: Video[]
}

export const RelatedVideosPlaylist: FunctionComponent<
  RelatedVideosPlaylistProps
> = ({ title, videos }) => {
  return (
    <>
      <Row
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: '1rem',
        }}
      >
        <h3 style={{ marginTop: '0' }}>{title}</h3>
        <p
          style={{
            margin: 0,
            fontWeight: 200,
            color: '#545D68',
            fontSize: '15px',
          }}
        >
          {`${videos.length + 1} in this series`}
        </p>
      </Row>
      <Row
        style={{
          border: '1px solid #C6C6C6',
          borderRadius: '12px',
          padding: '1rem',
          maxHeight: '360px',
          overflow: 'scroll',
        }}
      >
        <div style={{ overflow: 'hidden' }}>
          {videos.map((video) => (
            <VideoStrip
              {...video}
              thumbnail={video.thumbnails.medium.url}
              url={`/video/watch?videoId=${video?.id}`}
              key={video?.id}
              maxTitleLength={36}
            />
          ))}
        </div>
      </Row>
    </>
  )
}
